var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup2034(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.223,
    height: 22.54,
    viewBox: "0 0 23.223 22.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2034",
    "data-name": "Group 2034",
    transform: "translate(0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3797",
    "data-name": "Path 3797",
    d: "M-414.632,263.611l6.7,6.715a1.22,1.22,0,0,1,.151-.246q1.491-1.5,2.99-2.994c.31-.309.5-.31.808,0q2.155,2.154,4.309,4.309c.309.31.309.507,0,.806a7.326,7.326,0,0,1-4.2,1.985,10.909,10.909,0,0,1-7.439-1.77,16.323,16.323,0,0,1-6.152-6.748,10.909,10.909,0,0,1-1.141-4.842,7.678,7.678,0,0,1,2.095-5.492c.28-.292.485-.3.767-.014q2.174,2.172,4.346,4.347c.294.295.292.488-.007.788q-1.5,1.5-2.994,2.99A1.8,1.8,0,0,1-414.632,263.611Z",
    transform: "translate(418.608 -252.238)",
    fill: "none",
    stroke: "#4c5b71",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    transform: "translate(8.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3798",
    "data-name": "Path 3798",
    d: "M-257.1,324.4a3.073,3.073,0,0,0-1.038,1.44.246.246,0,0,1-.263.177,3.425,3.425,0,0,0-.87.134,1.161,1.161,0,0,0-.823,1.13,2.739,2.739,0,0,0,.187,1.383.405.405,0,0,1,.019.087c-.6.21-.71.743-.809,1.269-.064.34-.1.687-.139,1.031-.01.082-.017.149-.132.149q-1.8,0-3.6,0a.718.718,0,0,1-.089-.012.778.778,0,0,1-.009-.1c.044-1.193.063-2.387.14-3.578a11.682,11.682,0,0,1,.594-3.207,3.119,3.119,0,0,1,.911-1.443,1.439,1.439,0,0,1,.912-.336,1.108,1.108,0,0,1,.418.088,3.127,3.127,0,0,0,2.618.037,1.02,1.02,0,0,1,1.364.355,3.469,3.469,0,0,1,.3.58C-257.3,323.841-257.209,324.111-257.1,324.4Z",
    transform: "translate(264.667 -316.86)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3799",
    "data-name": "Path 3799",
    d: "M-148.766,361.1h-5.917c-.1-.448-.188-.875-.306-1.292a1.735,1.735,0,0,0-.709-1.079,1.518,1.518,0,0,1,.052-.153,3.315,3.315,0,0,0,.2-1.485,1.126,1.126,0,0,0-.527-.906,3.139,3.139,0,0,1,.9-1.354,1.27,1.27,0,0,1,.791-.285.791.791,0,0,1,.307.065,3.034,3.034,0,0,0,2.24.123.353.353,0,0,0,.077-.032.884.884,0,0,1,.736-.124,1.514,1.514,0,0,1,.782.494,4.351,4.351,0,0,1,.834,1.74,13.985,13.985,0,0,1,.441,2.728C-148.828,360.043-148.8,360.551-148.766,361.1Z",
    transform: "translate(163.294 -346.726)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3800",
    "data-name": "Path 3800",
    d: "M-228.166,244.067a2.723,2.723,0,0,1-1.493-.414,1.893,1.893,0,0,1-.814-1.746,14.3,14.3,0,0,1,.19-1.883,1.874,1.874,0,0,1,1.607-1.461,3.05,3.05,0,0,1,1.56.219,1.912,1.912,0,0,1,1.183,2.3,12.916,12.916,0,0,1-.437,1.545,1.952,1.952,0,0,1-1.345,1.362A3.735,3.735,0,0,1-228.166,244.067Z",
    transform: "translate(232.779 -238.538)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3801",
    "data-name": "Path 3801",
    d: "M-145.6,284.723c.137-.154.275-.307.412-.463a.739.739,0,0,0,.155-.764,3.534,3.534,0,0,1-.19-1.386,1.868,1.868,0,0,1,1.6-1.712,2,2,0,0,1,2.375,1.89,4.936,4.936,0,0,1,.027.738.783.783,0,0,0,.367.726c.157.106.318.206.5.323-.239.067-.459.133-.682.19a1.841,1.841,0,0,0-.742.363,2.237,2.237,0,0,1-1.126.524,2.246,2.246,0,0,1-1.325-.271,1,1,0,0,0-.379-.105c-.328-.015-.657,0-.986,0Z",
    transform: "translate(153.621 -277.546)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    "data-name": "Path 3802",
    d: "M-198,425.514c.089-.45.139-.868.259-1.266a.741.741,0,0,1,.807-.594c.153.016.3.106.451.112a1.725,1.725,0,0,0,.606-.062.7.7,0,0,1,.831.239,2.027,2.027,0,0,1,.316,1.013c.019.177.019.355.029.559Z",
    transform: "translate(202.493 -411.178)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    "data-name": "Path 3803",
    d: "M-189.222,383.814a1.034,1.034,0,0,1,.329-.958,1.411,1.411,0,0,1,1.574-.01.821.821,0,0,1,.334.683,6.774,6.774,0,0,1-.072.868.956.956,0,0,1-1.078.832.965.965,0,0,1-1.031-.933C-189.19,384.137-189.2,383.975-189.222,383.814Z",
    transform: "translate(194.31 -372.905)",
    fill: "#4c5b71"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2034);
export default __webpack_public_path__ + "static/media/Group 2034.ee251c1d37f53ea18802ff4f7a6797eb.svg";
export { ForwardRef as ReactComponent };